import styled from 'styled-components';

// Colors
import * as colors from '@drivesally/sally-ui/lib/libs/colors';

const Thumbnail = styled.img`
  width: 100px;
  height: 100px;
  object-fit: cover;
  border-radius: 6px;
  border: 1px solid ${colors.mediumBlueGrey};
  display: block;
`;

export default Thumbnail;
